interface Props {
  on: boolean;
  onChange: () => void;
  ariaLabel: string;
  disabled?: boolean;
}

export function Switch({ on, onChange, ariaLabel, disabled = false }: Props) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onChange();
      }}
      className={`profile-switch${on ? ' on' : ''}${disabled ? ' disabled' : ''}`}
    >
      <span className="profile-switch-thumb" />
    </button>
  );
}
